import { lazy } from 'react';
import { RouteConfig } from '../../types/routing.types';
import { Home } from 'lucide-react';

const Dashboard = lazy(() => import('./Dashboard'));

export const dashboardRoutes: RouteConfig[] = [
  {
    path: '/dashboard',
    component: Dashboard,
    label: 'Tableau de bord',
    icon: Home,
    showInNav: true,
    breadcrumb: ['Accueil'],
  },
];
